export default __webpack_public_path__ + "static/media/delievers13.fe708c3f.png";